const FallBack = ({
    title = "No Data Available",
    message = "We couldn’t load the requested information.",
    actionText,
    onAction,
}) => (
    <div className="flex flex-col items-center justify-center h-full text-center px-6 py-12">
        <div className="w-14 h-14 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center text-2xl font-bold mb-4">
            !
        </div>
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        <p className="text-sm text-gray-500 mt-2 max-w-md">{message}</p>

        {actionText && onAction && (
            <button
                onClick={onAction}
                className="mt-5 px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition"
            >
                {actionText}
            </button>
        )}
    </div>
);

export default FallBack;